import { useCallback, useMemo } from 'react';
import { HUBSPOT_APP_LINK_TYPES, useHubSpotAppLinkHandler } from '../common/context/HubSpotAppLinkHandlerContext';
import { shouldLinkToAssociation } from './internal/useAssociatedObjectsRecord';
import AssociatedRecordLink from './internal/AssociatedRecordLink';
import { trackLinkNavigation } from './internal/Metrics';
import { Link } from 'foundations-components/transitional/components/Link';
import RecordPageLink from './internal/RecordPageLink';
import { isSupportedNonRecordPageObjectType } from './internal/getRecordHref';
import NonRecordPageLink from './internal/NonRecordPageLink';
import { jsx as _jsx } from "react/jsx-runtime";
const RecordLink = ({
  children,
  external = false,
  hideIfNotSupported = false,
  includeEschref = false,
  LinkComponent = Link,
  LinkComponentProps = {},
  objectId,
  objectTypeId,
  onTrackClick
}) => {
  const linkHandler = useHubSpotAppLinkHandler(HUBSPOT_APP_LINK_TYPES.CRM_OBJECT_RECORD);
  const handleClick = useCallback(event => {
    if (onTrackClick) {
      onTrackClick({
        objectId,
        objectTypeId
      });
    }
    if (linkHandler.onClick) {
      linkHandler.onClick({
        objectId,
        objectTypeId
      }, event);
    }
    trackLinkNavigation({
      linkType: 'CRM_OBJECT_RECORD',
      linkTypeProps: {
        includeEschref,
        objectId,
        objectTypeId
      },
      external: (LinkComponentProps === null || LinkComponentProps === void 0 ? void 0 : LinkComponentProps.external) || external
    });
  }, [LinkComponentProps === null || LinkComponentProps === void 0 ? void 0 : LinkComponentProps.external, external, includeEschref, objectId, objectTypeId, onTrackClick, linkHandler]);
  const sharedProps = useMemo(() => {
    return {
      external,
      handleClick,
      hideIfNotSupported,
      includeEschref,
      LinkComponent,
      LinkComponentProps,
      objectId,
      objectTypeId
    };
  }, [external, handleClick, hideIfNotSupported, includeEschref, LinkComponent, LinkComponentProps, objectId, objectTypeId]);
  if (shouldLinkToAssociation(objectTypeId)) {
    return /*#__PURE__*/_jsx(AssociatedRecordLink, Object.assign({}, sharedProps, {
      children: children
    }));
  }
  if (isSupportedNonRecordPageObjectType(objectTypeId)) {
    return /*#__PURE__*/_jsx(NonRecordPageLink, Object.assign({}, sharedProps, {
      children: children
    }));
  }
  return /*#__PURE__*/_jsx(RecordPageLink, Object.assign({}, sharedProps, {
    hideIfNotSupported: hideIfNotSupported,
    onTrackClick: onTrackClick,
    children: children
  }));
};
export default RecordLink;